/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @angular-eslint/component-selector */
import {
  Component,
  OnInit,
  Input,
  AfterViewInit,
  OnChanges,
} from '@angular/core';
import {fabric} from 'fabric';
import * as uuid from 'uuid';
import * as ShapeMaker from '../../shapes/shape.maker';

@Component({
    selector: 'kanzi-floormap-preview-item',
    templateUrl: './floormap-preview-item.component.html',
    styleUrls: ['./floormap-preview-item.component.scss'],
    standalone: false
})
export class FloormapPreviewItemComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() type ='';
  @Input() furniture: any;
  id: any;
  canvas?: fabric.Canvas;

  ngOnInit(): void {
    this.id = uuid.v4();
  }

  ngOnChanges() {
    if (this.canvas) {
      this.handleObjectInsertion({ type: this.type, object: this.furniture });
      this.canvas.renderAll();
    }
  }

  ngAfterViewInit() {
    const canvas = new fabric.Canvas(this.id);
    canvas.setWidth(ShapeMaker.RL_PREVIEW_WIDTH);
    canvas.setHeight(ShapeMaker.RL_PREVIEW_HEIGHT);
    this.canvas = canvas;
    this.handleObjectInsertion({ type: this.type, object: this.furniture });
    this.canvas.renderAll();
  }

  handleObjectInsertion({ type, object }:any) {
    const group = ShapeMaker.createFurniture(type, object);
    group.left = ShapeMaker.RL_PREVIEW_WIDTH / 2;
    group.top = ShapeMaker.RL_PREVIEW_HEIGHT / 2;
    group.selectable = false;
    group.hoveCursor = 'pointer';
    group.zoom = 1;
    this.canvas?.add(group);
  }
}
